export default __webpack_public_path__ + "static/media/scriptIcon.664020b8.svg";